import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { WorkoutApi } from '../workout.api';
import { ApiHttpResponse, Workout } from '@kinomap-dev/ng-ui-lib';

@Injectable({
  providedIn: 'root',
  useClass: WorkoutApi,
})
export abstract class IWorkoutApi {
  abstract getWorkouts(
    page: number,
    limit: number,
    userId?: number
  ): Observable<ApiHttpResponse<Workout[]>>;
}
